/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FaqDto } from '../../models/faq-dto';

export interface FaqControllerFindAllV1$Params {
}

export function faqControllerFindAllV1(http: HttpClient, rootUrl: string, params?: FaqControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FaqDto>>> {
  const rb = new RequestBuilder(rootUrl, faqControllerFindAllV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FaqDto>>;
    })
  );
}

faqControllerFindAllV1.PATH = '/api/v1/faq';
